// packages/ui/src/session/recovery.ts
export interface RecoveryInput {
  kind: 'untitled' | 'file' | 'image';
  /** Draft content if present, else null. */
  draftText: string | null;
  /** Current on-disk content if the file was readable, else null (missing). */
  diskText: string | null;
}

export type RecoveryClass =
  | 'restore-untitled' // untitled buffer: silent restore from draft
  | 'open-disk' // no draft, or draft equals disk: open the disk file
  | 'conflict' // draft differs from disk: ask the user
  | 'restore-missing'; // draft exists but the file is gone: auto-restore dirty

export function classifyTab(input: RecoveryInput): RecoveryClass {
  if (input.kind === 'untitled') return 'restore-untitled';
  if (input.draftText == null) return 'open-disk';
  if (input.diskText == null) return 'restore-missing';
  return input.draftText === input.diskText ? 'open-disk' : 'conflict';
}
